import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#IconSocialWhatsapp16a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.764 4.064c-.155-.372-.272-.386-.508-.396a4.53 4.53 0 0 0-.268-.009c-.305 0-.625.09-.818.287-.235.24-.818.8-.818 1.947 0 1.148.837 2.258.95 2.413.118.155 1.632 2.544 3.982 3.518 1.839.762 2.384.691 2.803.602.61-.132 1.377-.583 1.57-1.129.193-.545.193-1.011.136-1.11-.056-.098-.211-.155-.446-.272-.235-.118-1.378-.682-1.594-.758-.212-.08-.414-.051-.574.174-.225.316-.446.635-.625.828-.141.15-.372.17-.564.09-.259-.109-.983-.363-1.876-1.158-.691-.615-1.162-1.382-1.298-1.612-.136-.236-.014-.372.094-.499.118-.146.23-.25.348-.386.118-.136.183-.207.259-.367.08-.155.023-.315-.033-.432-.057-.118-.527-1.266-.72-1.731ZM7.998 0C3.588 0 0 3.588 0 8a7.94 7.94 0 0 0 1.523 4.689L.527 15.66l3.075-.982A7.937 7.937 0 0 0 8.002 16C12.412 16 16 12.411 16 8s-3.587-8-7.998-8h-.004Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "IconSocialWhatsapp16a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconSocialWhatsapp16 = createIcon(IconComponent);